import { DeliveryInfoInput, DiningOptionBehavior, DiningOptionFragmentFragment, FulfillmentType } from 'src/apollo/onlineOrdering';

import { OORestaurant } from 'shared/components/common/restaurant_context/RestaurantContext';

import { Cart } from 'public/components/online_ordering/types';

export const getQuoteTime = (diningOptionBehavior: DiningOptionBehavior, restaurant: OORestaurant, cart?: Cart | null) =>
  diningOptionBehavior === DiningOptionBehavior.Delivery
    ? cart?.deliveryQuoteTime || restaurant.minimumDeliveryTime
    : cart?.takeoutQuoteTime || restaurant.minimumTakeoutTime;

export const getInitialFulfillmentForDiningOption = (diningOption: DiningOptionFragmentFragment | undefined | null, validDeliveryAddress?: DeliveryInfoInput | null) => {
  if(!diningOption) {
    return null;
  }
  const fulfillmentType = diningOption.asapSchedule?.availableNow ? FulfillmentType.Asap : FulfillmentType.Future;
  const fulfillmentDateTime = fulfillmentType === FulfillmentType.Future ? diningOption?.futureSchedule?.dates?.find(date => date?.times?.length)?.times?.[0]?.time : undefined;
  if(fulfillmentType === FulfillmentType.Future && !fulfillmentDateTime) {
    return null;
  }
  return {
    cartFulfillmentData: {
      fulfillmentType,
      diningOptionBehavior: diningOption.behavior,
      deliveryInfo: diningOption.behavior === DiningOptionBehavior.Delivery ? validDeliveryAddress : undefined,
      fulfillmentDateTime
    },
    scheduleData: {
      asapAvailableNow: diningOption.asapSchedule?.availableNow || false,
      futureScheduleDates: diningOption.futureSchedule?.dates || []
    }
  };
};

/**
 * Get the default fulfillment info as whatever is available first:
 *  1. takeout ASAP
 *  2. delivery ASAP
 *  3. takeout scheduled
 *  4. delivery scheduled
 */
export const getDefaultFulfillmentInfo = (
  rxDefaultDiningBehavior: DiningOptionFragmentFragment | undefined | null,
  diningOptionsByBehavior: {takeout: DiningOptionFragmentFragment | undefined,
    delivery: DiningOptionFragmentFragment | undefined},
  validDeliveryAddress?: DeliveryInfoInput | null
) => {
  const defaultFulfillment = getInitialFulfillmentForDiningOption(rxDefaultDiningBehavior, validDeliveryAddress);
  if(defaultFulfillment) {
    return defaultFulfillment;
  }
  const orderOfPreference = [
    'takeout',
    'delivery'
  ];

  for(const behavior of orderOfPreference) {
    const diningOption = diningOptionsByBehavior[behavior as keyof typeof diningOptionsByBehavior];
    if(diningOption?.asapSchedule?.availableNow) {
      return getInitialFulfillmentForDiningOption(diningOption, validDeliveryAddress);
    }
  }

  for(const behavior of orderOfPreference) {
    const diningOption = diningOptionsByBehavior[behavior as keyof typeof diningOptionsByBehavior];
    if(diningOption?.futureSchedule?.dates?.length) {
      return getInitialFulfillmentForDiningOption(diningOption, validDeliveryAddress);
    }
  }

  return null;
};
